var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(81.176471%,84.705882%,86.27451%)",
      fillOpacity: 1
    },
    d: "M 25 5.625 L 25 4.375 L 19.375 4.375 L 19.375 7.5 L 9.375 7.5 L 9.375 14.375 L 5 14.375 L 5 15.625 L 9.375 15.625 L 9.375 22.5 L 19.375 22.5 L 19.375 25.625 L 25 25.625 L 25 24.375 L 20.625 24.375 L 20.625 19.375 L 25 19.375 L 25 18.125 L 19.375 18.125 L 19.375 21.25 L 10.625 21.25 L 10.625 8.75 L 19.375 8.75 L 19.375 11.875 L 25 11.875 L 25 10.625 L 20.625 10.625 L 20.625 5.625 Z M 25 5.625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,73.72549%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 2.5 12.5 L 7.5 12.5 L 7.5 17.5 L 2.5 17.5 Z M 2.5 12.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,73.72549%,83.137255%)",
      fillOpacity: 1
    },
    d: "M 22.5 8.75 L 27.5 8.75 L 27.5 13.75 L 22.5 13.75 Z M 22.5 2.5 L 27.5 2.5 L 27.5 7.5 L 22.5 7.5 Z M 12.5 5.625 L 17.5 5.625 L 17.5 10.625 L 12.5 10.625 Z M 12.5 19.375 L 17.5 19.375 L 17.5 24.375 L 12.5 24.375 Z M 22.5 22.5 L 27.5 22.5 L 27.5 27.5 L 22.5 27.5 Z M 22.5 16.25 L 27.5 16.25 L 27.5 21.25 L 22.5 21.25 Z M 22.5 16.25 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.a254982e897d6b079672b0503cd659fd.svg";
export { ForwardRef as ReactComponent };